import cns from 'classnames';
import S from './LoadingSpinner.module.scss';
const LoadingSpinner = ({
  size,
  color = 'primary'
}: LoadingSpinnerProps) => {
  return <svg className={cns(S.loading, S[`color_${color}`])} width={size} height={size} viewBox="0 0 12 12" data-sentry-element="svg" data-sentry-component="LoadingSpinner" data-sentry-source-file="LoadingSpinner.tsx">
      <circle className={S.circle} cx="50%" cy="50%" r="5" stroke="currentColor" data-sentry-element="circle" data-sentry-source-file="LoadingSpinner.tsx"></circle>
    </svg>;
};
export default LoadingSpinner;
type LoadingSpinnerProps = {
  size: string;
  color: 'primary' | 'white';
};